module.exports = __webpack_public_path__ + "media/application/images/dashboard-image-413ae12f8e27156e51db962832270818.png";